import CmsModules from "theme/libs/wordpress/content/CmsModules";
import CustomerServiceHero from "theme/components/customerService/CustomerServiceHero";
import React from "react";
import { useSelector } from "react-redux";

const Default = () => {
    const pageContent = useSelector(({ page }) => page.data?.page_content);
    return (
        <>
            <CustomerServiceHero />
            {!!pageContent?.length && <CmsModules isCustomerService isWithoutBleedWrapper data={pageContent} />}
        </>
    );
};

export default Default;
